import { Form } from "react-bootstrap";

import { currencyFormat, formatDateForPanelDisplay } from "../../../../../Utils/helper";
import { getFullName, getLimitDisplay } from "../../../helpers/helpers";

export const formatClaimInformation = (insuranceData) => [
  {
    label: "Type",
    value: insuranceData?.insurance_type?.name,
  },
  {
    label: "Limits",
    value: getLimitDisplay(insuranceData),
  },
  {
    label: "Policy",
    value: insuranceData?.policy_number,
  },
  {
    label: "Claim",
    value: insuranceData?.claim_number,
  },
  {
    label: "Date",
    value: formatDateForPanelDisplay(insuranceData?.Dateconfirmedactive),
  },
];

export const formatLienInformation = (insuranceData, _billData) => [
  {
    label: "Lien Adjuster",
    value: insuranceData?.lien_adjuster?.name || "",
  },
  // {
  //   label: "HI Paid",
  //   value: billData?.total_ins_paid ? currencyFormat(billData.total_ins_paid) : "$ 0.00",
  // },
  // {
  //   label: "Medpay/Pip",
  //   value: billData?.total_medpaypaip ? currencyFormat(billData.total_medpaypaip) : "$ 0.00",
  // },
  {
    label: "ERISA Protected Lien",
    value: (
      <Form.Check
        style={{
          width: "15px",
          height: "15px",
          accentColor: "grey",
        }}
        type="checkbox"
        className="protection-lien-cb"
        name="protection_lien"
        checked={insuranceData?.ERISAYN || false}
        readOnly
      />
    ),
  },
  // {
  //   label: "",
  //   value: "",
  // },
  {
    label: "Total Paid",
    value: insuranceData?.insurancelien_insurance?.totalpaid
      ? currencyFormat(insuranceData.insurancelien_insurance.totalpaid)
      : "$ 0.00",
  },
  {
    label: "Original Lien",
    value: insuranceData?.insurancelien_insurance?.liens
      ? currencyFormat(insuranceData.insurancelien_insurance.liens)
      : "$ 0.00",
  },
  {
    label: "Final Lien",
    value: insuranceData?.insurancelien_insurance?.lienfinal
      ? currencyFormat(insuranceData.insurancelien_insurance.lienfinal)
      : "$ 0.00",
  },
];

export const getContactData = (contact, type) => ({
  name: type !== "company" ? getFullName(contact) : contact?.name,
  address1: contact?.address1,
  address2: contact?.address2,
  email: contact?.email,
  phone_number: contact?.phone_number,
  fax_number: contact?.fax,
  city: contact?.city,
  state: contact?.state,
  zip_code: contact?.zip,
  ext: contact?.ext,
  websiteURL: contact?.website,
});
